import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import DashboardIcon from "@mui/icons-material/Dashboard";
import StarIcon from "@mui/icons-material/Star";
import FavoriteIcon from "@mui/icons-material/Favorite";
import InfoIcon from "@mui/icons-material/Info";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import SecurityIcon from "@mui/icons-material/Security";

import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";
import PeopleIcon from "@mui/icons-material/People";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import CloudIcon from "@mui/icons-material/Cloud";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import StorageIcon from "@mui/icons-material/Storage";
import DatabaseIcon from "@mui/icons-material/Storage";

import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ArticleIcon from "@mui/icons-material/Article";
import AttachFileIcon from "@mui/icons-material/AttachFile";

import CodeIcon from "@mui/icons-material/Code";
import BugReportIcon from "@mui/icons-material/BugReport";
import BuildIcon from "@mui/icons-material/Build";
import ExtensionIcon from "@mui/icons-material/Extension";
import TerminalIcon from "@mui/icons-material/Terminal";

import TableChartIcon from "@mui/icons-material/TableChart";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import AssessmentIcon from "@mui/icons-material/Assessment";
import TimelineIcon from "@mui/icons-material/Timeline";
import BarChartIcon from "@mui/icons-material/BarChart";
import PieChartIcon from "@mui/icons-material/PieChart";

import LinkIcon from "@mui/icons-material/Link";
import ShareIcon from "@mui/icons-material/Share";
import PublicIcon from "@mui/icons-material/Public";
import LanguageIcon from "@mui/icons-material/Language";

import MapIcon from "@mui/icons-material/Map";
import PlaceIcon from "@mui/icons-material/Place";
import NavigationIcon from "@mui/icons-material/Navigation";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventIcon from "@mui/icons-material/Event";
import ScheduleIcon from "@mui/icons-material/Schedule";

import EmailIcon from "@mui/icons-material/Email";
import SendIcon from "@mui/icons-material/Send";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";

import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export const ICON_REGISTRY = {
    // navigation
    home: HomeIcon,
    dashboard: DashboardIcon,
    search: SearchIcon,

    // folders & files
    folder: FolderIcon,
    folderOpen: FolderOpenIcon,
    file: InsertDriveFileIcon,
    document: DescriptionIcon,
    article: ArticleIcon,
    attach: AttachFileIcon,

    // actions
    add: AddIcon,
    remove: RemoveIcon,
    edit: EditIcon,
    delete: DeleteIcon,
    save: SaveIcon,
    clear: ClearIcon,
    check: CheckIcon,
    close: CloseIcon,

    // visibility & security
    visible: VisibilityIcon,
    hidden: VisibilityOffIcon,
    lock: LockIcon,
    unlock: LockOpenIcon,
    security: SecurityIcon,

    // users
    person: PersonIcon,
    group: GroupIcon,
    people: PeopleIcon,
    account: AccountCircleIcon,

    // cloud & storage
    cloud: CloudIcon,
    cloudUpload: CloudUploadIcon,
    cloudDownload: CloudDownloadIcon,
    storage: StorageIcon,
    database: DatabaseIcon,

    // dev / tech
    code: CodeIcon,
    bug: BugReportIcon,
    build: BuildIcon,
    extension: ExtensionIcon,
    terminal: TerminalIcon,

    // data & views
    table: TableChartIcon,
    list: ViewListIcon,
    grid: ViewModuleIcon,
    assessment: AssessmentIcon,
    timeline: TimelineIcon,
    barChart: BarChartIcon,
    pieChart: PieChartIcon,

    // links & sharing
    link: LinkIcon,
    share: ShareIcon,
    public: PublicIcon,
    language: LanguageIcon,

    // location
    map: MapIcon,
    place: PlaceIcon,
    navigation: NavigationIcon,

    // time
    calendar: CalendarTodayIcon,
    event: EventIcon,
    schedule: ScheduleIcon,

    // communication
    email: EmailIcon,
    send: SendIcon,
    notifications: NotificationsIcon,
    notificationsOff: NotificationsOffIcon,

    // status
    info: InfoIcon,
    help: HelpOutlineIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    report: ReportProblemIcon,
    success: CheckCircleIcon,
    cancel: CancelIcon,

    // favorites
    star: StarIcon,
    favorite: FavoriteIcon,

    // settings
    settings: SettingsIcon,
} as const;

export type IconName = keyof typeof ICON_REGISTRY;
